/**
 * @generated SignedSource<<d69525c88e290df40b996813b0937092>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type Verb = "ACCOUNT_CHANGED" | "ADDED_DUE_DATE" | "ASSIGNED_ACTION_ITEM" | "ASSIGNED_TALKING_POINT" | "BILLING_ADDON_APPLIED" | "BILLING_ADDON_REMOVED" | "BILLING_PLAN_CANCELLED" | "BILLING_PLAN_CHANGED" | "BILLING_PLAN_UNCANCELLED" | "CHANNEL_NEW_MEMBER" | "CHANNEL_NEW_POST" | "COMMENT_MENTION" | "COMMENT_NEW" | "COMMENT_REPLY" | "COMMENT_RESOLVE" | "COMPLETED_ACTION_ITEM" | "EDITED_DUE_DATE" | "EDITED_NOTE" | "EDITED_STREAM_DESCRIPTION" | "GAVE_FEEDBACK" | "GAVE_MEETING_FEEDBACK" | "GAVE_PRAISE" | "KEY_RESULT_ASSIGNED" | "KEY_RESULT_ASSIGNED_TEAM" | "KEY_RESULT_CREATED_FLOATING_DESCRIPTION" | "KEY_RESULT_CURRENT_VALUE_CHANGE" | "KEY_RESULT_DELETED" | "KEY_RESULT_DUE_DATE_CHANGE" | "KEY_RESULT_START_VALUE_CHANGE" | "KEY_RESULT_TARGET_VALUE_CHANGE" | "KEY_RESULT_UPDATED" | "MEETING_BRIEF_READY" | "MEETING_COPILOT_PAYG_AMOUNT_CHANGED" | "MENTIONED_USER" | "MERGED_STREAMS" | "OBJECTIVE_ARCHIVED" | "OBJECTIVE_ASSIGNED" | "OBJECTIVE_ASSIGNED_TEAM" | "OBJECTIVE_CREATED" | "OBJECTIVE_CREATED_FLOATING_DESCRIPTION" | "OBJECTIVE_DELETED" | "OBJECTIVE_DUE_DATE_CHANGE" | "OBJECTIVE_PROGRESS" | "OBJECTIVE_STATUS_CHANGE" | "OBJECTIVE_UPDATED" | "PAYMENT_INFORMATION_UPDATED" | "RECORDING_ADDED" | "RECORDING_FIRST_VIEWED" | "REMINDED_FEEDBACK_RESPONSE" | "REQUESTED_FEEDBACK" | "RESPONDED_TO_FEEDBACK_REQUEST" | "SHARED_FEEDBACK" | "SHARED_STREAM" | "STAY_INCENTIVE_DISCOUNT_APPLIED" | "STAY_INCENTIVE_REFUND_APPLIED" | "TRIAL_EXTENDED" | "TRIAL_RESTARTED" | "UNSHARED_STREAM" | "USER_ACTIVATED" | "USER_APP_ACTIVATED" | "USER_APP_DEACTIVATED" | "USER_CREATED" | "USER_DEACTIVATED" | "USER_DELEGATION_CREATED" | "USER_DELEGATION_REMOVED" | "USER_DELETED" | "USER_DISABLED" | "USER_EXPORT_REQUESTED" | "USER_INVITED_GUEST" | "USER_JOINED_FROM_INVITE" | "USER_JOINED_FROM_INVITE_LINK" | "USER_JOINED_FROM_SELF_SIGNUP" | "USER_LEFT_SHARED_STREAM" | "USER_LOGIN" | "USER_LOGIN_DELEGATED" | "USER_LOGOUT" | "USER_LOGOUT_DELEGATED" | "USER_UPDATED" | "WORKSPACE_APP_ACTIVATED" | "WORKSPACE_APP_DEACTIVATED";
import { FragmentRefs } from "relay-runtime";
export type UpdatesViewer$data = {
  readonly id: string;
  readonly updates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly actor: {
          readonly email: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
        } | null;
        readonly assignee?: {
          readonly __typename: "User";
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
          readonly lastName: string;
        } | null;
        readonly assigneeTeam?: {
          readonly __typename: "Team";
          readonly id: string;
          readonly title: string;
        } | null;
        readonly cache: any;
        readonly createdAt: string;
        readonly data: any;
        readonly id: string;
        readonly keyResult?: {
          readonly __typename: "KeyResult";
          readonly id: string;
          readonly title: string;
        } | null;
        readonly objective?: {
          readonly __typename: "Objective";
          readonly title: string;
          readonly url: string | null;
        } | null;
        readonly verb: Verb;
      };
    } | null>;
  };
  readonly " $fragmentType": "UpdatesViewer";
};
export type UpdatesViewer$key = {
  readonly " $data"?: UpdatesViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdatesViewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "updates"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = {
  "alias": "assignee",
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "indirectObject",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = [
  (v2/*: any*/),
  (v1/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": "keyResult",
  "args": null,
  "concreteType": "KeyResult",
  "kind": "LinkedField",
  "name": "object",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": "assigneeTeam",
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "indirectObject",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v9 = [
  (v7/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": 50,
      "kind": "LocalArgument",
      "name": "last"
    },
    {
      "kind": "RootArgument",
      "name": "objectiveId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./UpdatesPaginationQuery.graphql')
    }
  },
  "name": "UpdatesViewer",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "updates",
      "args": [
        {
          "kind": "Variable",
          "name": "outerObjectId",
          "variableName": "objectiveId"
        }
      ],
      "concreteType": "ActivityConnection",
      "kind": "LinkedField",
      "name": "__updates_updates_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ActivityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "actor",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "image",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "verb",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cache",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "data",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v4/*: any*/)
                  ],
                  "type": "ObjectiveAssignedActivity",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v4/*: any*/),
                    (v7/*: any*/)
                  ],
                  "type": "KeyResultAssignedActivity",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v8/*: any*/)
                  ],
                  "type": "ObjectiveAssignedTeamActivity",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v8/*: any*/),
                    (v7/*: any*/)
                  ],
                  "type": "KeyResultAssignedTeamActivity",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v9/*: any*/),
                  "type": "KeyResultStartValueChangeActivity",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v9/*: any*/),
                  "type": "KeyResultCurrentValueChangeActivity",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v9/*: any*/),
                  "type": "KeyResultTargetValueChangeActivity",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v9/*: any*/),
                  "type": "KeyResultDueDateChangeActivity",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v9/*: any*/),
                  "type": "KeyResultDeletedActivity",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v9/*: any*/),
                  "type": "KeyResultUpdatedActivity",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "objective",
                      "args": null,
                      "concreteType": "Objective",
                      "kind": "LinkedField",
                      "name": "outerObject",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        (v5/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "ObjectiveCreatedFloatingDescription",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v9/*: any*/),
                  "type": "KeyResultCreatedFloatingDescription",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "c5a88116aab0cc1eca015651954a2ce6";

export default node;
